"use client";

import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function ZonaPPGrid({
  children,
  className,
  columns
}: {
  children: React.ReactNode;
  className?: string;
  columns: {
    desktop: number;
    tablet: number;
    mobile: number;
  };
}) {
  return <div className={`grid grid-cols-${columns.mobile} md:grid-cols-${columns.tablet} lg:grid-cols-${columns.desktop} gap-6 ${className || ""}`}>
      {children}
    </div>;
}
function ZonaPPCard({
  image,
  nama,
  peran,
  wilayah,
  className,
  "data-index": dataIndex
}: any) {
  return <div data-index={dataIndex} className={`group flex flex-col items-center text-center h-full ${className || ""}`}>
      <div className="relative w-full aspect-[3/4] mb-4 overflow-hidden rounded-lg bg-muted/30 border border-border/50">
        {image.src && <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={nama} loading="lazy" className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-105" />}
        {}
        <div className="absolute inset-0 border-2 border-transparent group-hover:border-primary/50 transition-colors rounded-lg pointer-events-none" />
      </div>
      <h3 className="font-bold text-base text-foreground mb-1 group-hover:text-primary transition-colors line-clamp-2">
        {nama}
      </h3>
      {peran && <p className="text-sm text-muted-foreground line-clamp-2">
          {peran}
        </p>}
      {wilayah && <p className="text-xs font-medium text-primary mt-1 uppercase tracking-wider">
          {wilayah}
        </p>}
    </div>;
}
function ProfileGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <ZonaPPGrid className="zona-pp-grid-profile" columns={{
      desktop: 6,
      tablet: 3,
      mobile: 1
    }}>
        {[...Array(6)].map((_, i) => <div key={i} data-index={i} className="flex flex-col items-center animate-pulse">
            <div className="w-full aspect-[3/4] rounded-lg bg-accent mb-4" />
            <div className="h-5 w-3/4 bg-accent mb-2 rounded" />
            <div className="h-4 w-1/2 bg-accent rounded" />
          </div>)}
      </ZonaPPGrid>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Gagal memuat data profil. Silakan coba lagi nanti.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground">
        <p>Belum ada data profil yang tersedia saat ini.</p>
      </div>;
  }
  return <ZonaPPGrid className="zona-pp-grid-profile" columns={{
    desktop: 6,
    tablet: 3,
    mobile: 1
  }}>
      {posts.map((post, i) => {
      const nama = post.customFields?.nama || post.title;
      const peran = post.customFields?.peran;
      const wilayah = post.customFields?.wilayah;
      const image = {
        src: post.customFields?.gambar || post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/placeholder_portrait.png",
        srcset: "",
        sizes: ""
      };
      return <ZonaPPCard key={post.id} data-index={i} className="zona-pp-card-portrait" image={image} nama={nama} peran={peran} wilayah={wilayah} />;
    })}
    </ZonaPPGrid>;
}
export default function ZonaPPProfileGrid() {
  const wp_query_params = {
    post_type: "zona_pp_profile",
    per_page: 6,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="zonappprofilegrid" className="bg-background py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 text-center md:text-left">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground uppercase tracking-tight font-default">
            Profil <span className="text-primary">Tokoh</span>
          </h2>
          <div className="h-1 w-16 bg-primary mt-3 mx-auto md:mx-0 rounded-lg"></div>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "zona_pp_profile",
        per_page: 6,
        orderby: "date",
        order: "desc"
      }}>
          <ProfileGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}